import card_generation_icon from "../assets/icons/card_generation.svg";
import address_icon from "../assets/icons/address_book.svg";
import calender_icon from "../assets/icons/calender.svg";
import logo_black from "../assets/icons/logo_black.svg";
import draft_icon from "../assets/icons/draft.svg";
import { PiAddressBookBold } from "react-icons/pi";
import premium_icon from "../assets/icons/premium_plan.svg";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { RiLogoutBoxLine } from "react-icons/ri";
import { useEffect, useState } from "react";

const SidePanel = () => {
  const topLinks = [
    {
      name: "My Cards",
      icon: logo_black,
      path: "/dashboard/print",
    },
    {
      name: "Card Generation",
      icon: card_generation_icon,
      path: "/dashboard/card_generation",
    },
    {
      name: "Address Book",
      icon: <PiAddressBookBold size={24} className="mr-3" />,
      path: "/dashboard/address_book",
    },
    { name: "Calendar", icon: calender_icon, path: "/dashboard/calender" },
    { name: "Drafts & Favorites", icon: draft_icon, path: "/dashboard/draft" },
    {
      name: "Subscription Plans",
      icon: premium_icon,
      path: "/dashboard/premium_plan",
    },
  ];
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [loader, setLoader] = useState(true);
  useEffect(() => {
    const fetchUserProfile = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        // Handle case where the user is not logged in or the token is not available
        console.error("No token found");
        setLoader(false); // Stop loading if there's an error
        return;
      }
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/auth/me`,
          {
            // Adjusted to point to a profile endpoint
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": token,
            },
          }
        );
        const data = await response.json();
        if (data) {
          setIsSubscribed(data.detail.isSubscribed);
        }
      } catch (error) {
        console.error("Failed to fetch user profile:", error);
      } finally {
        setLoader(false);
      }
    };

    fetchUserProfile();
  }, []);

  const { pathname } = useLocation();
  return (
    <div>
      <div className="fixed top-[4rem] left-0 xl:block hidden xl:text-lg text-md xl:w-[18%] w-[20%] px-3 flex-col justify-between h-[calc(100vh-4rem)] border-r-2 border-slate-300 overflow-y-auto bg-white z-40">
        <div className="my-5">
          {topLinks.map((link) => (
            <Link to={link.path} key={link.name}>
              <button
                className={`flex items-center my-3 px-1 border-2 py-3 rounded-md w-full 
            ${
              pathname === link.path
                ? "bg-primary-light border-primary"
                : "border-transparent"
            }
            hover:border-primary`}
              >
                <span>
                  {link.name === "Address Book" ? (
                    link.icon
                  ) : (
                    <img
                      src={link.icon}
                      alt={link.name}
                      width={25}
                      className="mr-3"
                    />
                  )}
                </span>
                {link.name}
              </button>
            </Link>
          ))}
        </div>
      </div>{" "}
    </div>
  );
};

export default SidePanel;
